import { useLayoutEffect, useRef } from "react";
import { gsap } from "@/lib/gsap";

const LINES = ["PHOTOGRAPHY", "SHOULD", "FEEL LIKE", "SOMETHING."];

export default function TypographyTakeover({ image }) {
  const root = useRef(null);

  useLayoutEffect(() => {
    if (!image) return undefined;
    const ctx = gsap.context(() => {
      const q = gsap.utils.selector(root);
      const tl = gsap.timeline({
        scrollTrigger: { trigger: root.current, start: "top top", end: "+=300%", pin: true, scrub: 0.6, anticipatePin: 1, pinType: "fixed", refreshPriority: 1 },
      });
      tl.fromTo(q(".tt-line"), { clipPath: "inset(0 0 100% 0)", yPercent: 40 }, { clipPath: "inset(0 0 0% 0)", yPercent: 0, stagger: 0.5, duration: 0.8, ease: "power2.out" }, 0)
        .fromTo(q(".tt-bg"), { filter: "blur(24px) brightness(0.4)", scale: 1.18 }, { filter: "blur(0px) brightness(0.65)", scale: 1, duration: 2.6, ease: "none" }, 0.2)
        .to(q(".tt-line"), { color: "#ffffff", duration: 0.5 }, 2)
        .to({}, { duration: 0.5 });
    }, root);
    return () => ctx.revert();
  }, [image]);

  return (
    <section ref={root} className="relative h-[100svh] w-full overflow-hidden bg-[#000000]" data-testid="typography-takeover">
      <img src={image} alt="" className="tt-bg absolute inset-0 h-full w-full object-cover object-[50%_30%] will-change-transform" />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-black/70" />
      <div className="relative z-10 h-full flex flex-col justify-center px-5 sm:px-8">
        {LINES.map((l) => (
          <span key={l} className="tt-line block font-display font-extrabold text-white/90 text-[clamp(1.5rem,7vw,8.4rem)] leading-[0.88] tracking-[-0.035em] will-change-transform" data-testid="tt-line">
            {l}
          </span>
        ))}
      </div>
    </section>
  );
}
